<template>
  <!-- User Card -->
  <div class="navigation-sidebar-user">
    <div class="dropdown w-100">
      <button class="btn p-0 border-0 w-100 text-start" data-bs-toggle="dropdown">
        <div class="d-flex align-items-center">
          <div class="navigation-sidebar-user__user-info ms-3">
            <div class="navigation-sidebar-user__name mb-1">
              {{ displayName }}
            </div>

            <span
              :class="`badge badge-pill navigation-sidebar-user__badge ${stagingColor.chipColorClass}`"
            >
              {{ stagingColor.chipText }}
            </span>
          </div>

          <i class="bi bi-chevron-up ms-auto"></i>
        </div>
      </button>

      <ul class="dropdown-menu dropdown-menu-end w-100 navigation-sidebar-user__dropdown">
        <li v-for="item in USER_MENU_LINKS" :key="item.route">
          <NavigationMainLinks :link-info="item" />
        </li>

        <li>
          <hr class="dropdown-divider" />
        </li>

        <li>
          <button
            class="dropdown-item navigation-sidebar-user__dropdown-item text-danger"
            @click="logout"
          >
            <i class="bi bi-box-arrow-right me-2"></i>
            Logout
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import { USER_MENU_LINKS } from '@/components/navigation/constants/NAVIGATION';
import NavigationMainLinks from '@/components/navigation/NavigationMainLinks.vue';
import { RouteNames } from '@/router/constants/routeName';
import { type StagingColor } from '@/utils';

type Props = {
  displayName: string;
  stagingColor: StagingColor;
};

defineProps<Props>();

const router = useRouter();

const logout = () => {
  router.push({ name: RouteNames.Logout });
};
</script>

<style lang="scss" scoped>
.navigation-sidebar-user {
  padding: 1rem 0.5rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 0.0625rem solid rgba(255, 255, 255, 0.08);
}

.navigation-sidebar-user .btn {
  color: white;
}

.navigation-sidebar-user .btn:focus {
  box-shadow: none;
}

/* Avatar */
.navigation-sidebar-user__user-info {
  overflow: hidden;
}

.navigation-sidebar-user__name {
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.navigation-sidebar-user__badge {
  margin-top: 0.35rem;
}

/* Dropdown */
.navigation-sidebar-user__dropdown {
  border-radius: 0.625rem;
  border: none;
  padding: 0.5rem;
  box-shadow: 0 0.75rem 2.1875rem rgba(0, 0, 0, 0.35);
}

.navigation-sidebar-user__dropdown-item {
  border-radius: 0.625rem;
  padding: 0.65rem 0.9rem;
  transition: 0.2s;
}
</style>
